module.exports = __webpack_public_path__ + "static/media/gregJavardian_crop.9f499dea.png";